import { deleteColor, getColoresPanel} from "../../services/ColoresServices";
import { ColoresContext } from "./ColoresContext"

export const ColoresState = ({ children }) => {
    const getColoresPanelData = async (search,numpag,filas) => {
        let res = await getColoresPanel(search,numpag,filas)
        return res
    }

    const deleteColorData = async (body,search,numpag,filas) => {
        const res = await deleteColor(body)
        if (res) getColoresPanelData(search,numpag,filas)
        return res
    }

    return <ColoresContext.Provider value={{
        deleteColorData,
        getColoresPanelData,
    }} >
        {children}
    </ColoresContext.Provider>
}